import { ServiceCentresActions, ServiceCentresState } from "types/store";

const initialState: ServiceCentresState = {
  search: ""
};

export default function serviceCentresReducer(
  state: ServiceCentresState = initialState,
  action: ServiceCentresActions
): ServiceCentresState {
  switch (action.type) {
    case "SET_SERVICE_CENTRES_TABLE":
      return {
        ...state,
        serviceCentres: action.payload,
      };
   case "SET_SERVICE_CENTRES_SEARCH":
      return {
        ...state,
        search: action.payload,
      };
    case "SET_SELECTED_SERVICE_CENTRE":
      return {
        ...state,
        selectedServiceCentre: action.payload,
      };
      case "SET_MAINTENANCE_SERVICES_LIST":
          return {
              ...state, maintenanceServicesList: action.payload
          }
    default:
      return state;
  }
}


